import { Box, Stack, Tabs, TabsProps } from '@chakra-ui/react';

type Props = TabsProps & {
	children: React.ReactNode;
	panels?: React.ReactNode;
	mb?: number;
};

export const ToggleStack: React.FC<Props> = ({
	children,
	panels,
	mb = 4,
	...rest
}) => {
	return (
		<Tabs size="sm" variant="soft-rounded" {...rest}>
			<Stack mb={mb}>
				<Box
					borderRadius="full"
					border="1px"
					borderColor="chakra-border-color"
					p="1"
					width="fit-content"
					height="fit-content"
				>
					{children}
				</Box>
			</Stack>
			{panels}
		</Tabs>
	);
};
